import React, { useEffect, useState } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import moment from 'moment-jalali';


const initialValues = {
    title: '',
    subGuildId: '',
    issueType:''
};


const validationSchema = Yup.object({
    title: Yup.string()
        .required('این فیلد الزامی است..')
        .min(2, "تعداد حروف کم است  ")
        .max(50, "تعداد حروف زیاد است ")
});


const Create = () => {

    const { id } = useParams();
    const { readDataById } = useEntityCrud('Opinions/get');
    const { addData: updateData } = useEntityCrud('Role/UpdateRole');
    const navigate = useNavigate();

    const { updateDate } = useEntityCrud("Opinions/Update")

    const [issueType2, setIssueType2] = useState(null);
    const [fromdate, setFromdate] = useState(null);
    const [todate, setTodate] = useState(null);
    const [checkComment, setCheckComment] = useState(false);

    const { readData } = useEntityCrud('Guild/GetAllGuilds');
    const [options, setOptions] = useState([]);
    const [file, setFile] = useState('');


    function convertToDate(date) {
        if (!date)
            return ""
        return moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("YYYY-MM-DDTHH:mm:ss.SSSZ")
    }

    function convertDateToInputValue(date) {
        if (!date) return "";
        const shamsiDate = new Date(date).toLocaleDateString("fa-ir-u-nu-latn", {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        });
        var arr = shamsiDate.split("/");

        return {
            day: parseInt(arr[2]),
            month: parseInt(arr[1]),
            year: parseInt(arr[0]),
        };
    }

    useEffect((e) => {
         

        readData().then(({ data }) => {
             
            if (data.status) {
                let guilds = data.result.filter(item => item.isActive);
                setOptions(guilds);
            }
        });
        readDataById(id).then(({ data }) => {
             
            if (data.status) {
                formik.setValues({
                    ...data.result
                });
                if(data.result.issueType === 1){
                    formik.setValues({
                        ...data.result,
                        issueType : 2
                    }); 
                }
                else{
                    formik.setValues({
                        ...data.result,
                        issueType : 1
                    }); 
                }

            }
            console.log(data.result.smsInterval);
            setFromdate(convertDateToInputValue(data.result.fromdate))
            setTodate(convertDateToInputValue(data.result.todate))
            setIssueType2(data.result.issueDay === 0 ? 2 : 1)
            setFile("data:image/jpeg;base64," + data.result.logo)

/*             setOptions({ id: data.result.guildId, title: options?.find(item1 => item1.id === data.result.guildId)?.title })
 */        });
    }, []);



    const onSubmit = (values) => {
         
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            "title": values.title,
            "status": true,
            "fromdate": convertToDate(fromdate),
            "todate": ((parseInt(issueType2) != 1) ? convertToDate(todate) : convertToDate(fromdate)) || "2023-06-17T10:41:13.791Z",
            "createDate": convertToDate(fromdate),
            "issueType": (parseInt(values.issueType) === 1 ? 0 : 1) || 0,
            "issueDay": (parseInt(issueType2) != 1) ? 0 : parseInt(values.issueDay),
            "guildId": parseInt(values.guildId),
            "smsInterval": (parseInt(values.smsInterval)) || 0,
            "openComment": checkComment,
            "logo": file || "",
            "subGuildId": parseInt(values.subGuildId)
        };
        updateDate({ ...postedData, id }).then(({ data }) => {
             
            if (data.status) {
                toast.success('به روزرسانی نظرسنجی با موفقیت انجام شد');
                return navigate('/survey');
            } else
                data?.errors?.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });


    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش نقش</div>
                <a className="backIconLink" onClick={() => navigate(-1)}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik}
                    file={file}
                    setFile={setFile}
                    issueType2={issueType2}
                    setIssueType2={setIssueType2}
                    isEditMode={true}
                    checkComment={checkComment} setCheckComment={setCheckComment}
                    fromdate={fromdate} setFromdate={setFromdate}
                    todate={todate} setTodate={setTodate}
                    setOptions={setOptions} options={options} />
            </div>
        </div>
    );
}

export default Create;